import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert } from '@gravity-ui/uikit';

import { Const } from '@const/public';
import { useClientContext } from '@client/lib/ClientContext';

export const IndexNeedAuthAlert: React.FC = () => {
    const [{ authKey }] = useClientContext();

    const navigate = useNavigate();

    const handleCloseAlert = React.useCallback(() => {
        navigate('/', { replace: true });
    }, []);

    const actions = React.useMemo(() => [
        {
            text: 'Авторизоваться',
            handler: () => {
                window.location.href = `https://t.me/${Const.TELEGRAM_BOT_USERNAME}?start=${authKey}`;
            },
        },
    ], []);

    return (
        <Alert
            onClose={handleCloseAlert}
            theme="danger"
            message="Для просмотра этой страницы необходимо авторизоваться!"
            corners="square"
            actions={actions}
        />
    );
};
